import { IProvided, useEventGetters } from '@/hooks/useEventGetters';
import theme from '@/js/themes/coeo_manager';
import { IEvent } from '@/types/event';
import { IProgramRoom } from '@/types/room'; 
import React, { ReactNode } from 'react';
import { EventListItem } from '.';
import { Box } from '@mui/material';

type Provided = IProvided & {
  event: IEvent;
};

interface IProps {
  list: IEvent[][];
  rooms: IProgramRoom[];
  stepper: Record<'current' | 'finished', string[]>;
  children: (provided: Provided) => ReactNode;
}

const useStyles = () => ({
  ul: {
    padding: '0px !important',
    margin: '0px !important',
    marginTop: `${theme.spacing(2)} !important`,
    listStyle: 'none !important',
  },
  li: {
    display: 'flex !important',
    flexWrap: 'wrap !important',
  },
});

export const EventList = ({
  list = [],
  rooms,
  stepper = { current: [], finished: [] },
  children,
}: IProps) => {
  const classes = useStyles();
  
  return (
    <Box component="ul" sx={classes.ul}>
      {list.map((events, count) => (
        <Box component="li" key={count} sx={classes.li}>
          {events.map((event, index) => (
            <EventListItem
              key={event.id}
              multiple={events.length > 1}
              isLastEvent={count === list.length - 1}
              isFirstEvent={index === 0}
              eventPassed={stepper.finished.includes(event.id)}
              eventLive={stepper.current.includes(event.id)}
              startTime={event.start_time}
            >
              {children({
                event,
                ...useEventGetters(event, rooms, stepper),
              })}
            </EventListItem>
          ))}
        </Box>
      ))}
    </Box>
  );
};
